import axios, { AxiosInstance } from "axios";
import { globalStore, Error } from "@/store/modules/GlobalStore";
import _ from "lodash";

export class BaseService {
  protected client: AxiosInstance;

  constructor() {
    this.client = axios.create();
    this.client.interceptors.response.use(
      (r) => r,
      (error) => {
        if (error.response.status !== 401) {
          // if has response show the error
          if (error.response.data) {
            globalStore.setError(
              new Error(
                error,
                error.response.status,
                _.truncate(error.response.data),
              ),
            );
          } else {
            globalStore.setError(new Error(error));
          }
        }
        return Promise.reject(error);
      },
    );
  }
}
